////
/// ============================================================================
/// COMPONENT / Table
/// ============================================================================
///
/// @group components
////
import { debounce } from "../utils/debounce";

function wrap(element, wrapper) {
    element.parentNode.insertBefore(wrapper, element);
    wrapper.appendChild(element);
}

export default () => {
    document.querySelectorAll("table").forEach(table => {
        // 1) Caso migliore: .js-table > div > table
        if (table.parentElement.parentElement.classList.contains("js-table")) {
            return;
        }

        // 2) .js-table > table
        const wrapper = document.createElement('div');

        if (table.parentElement.classList.contains("js-table")) {
            wrap(table, wrapper);
            return;
        }

        // 3) table
        const block = document.createElement('div');
        block.classList.add("js-table");

        wrap(table, wrapper);
        wrap(wrapper, block);
    });

    function fix(block) {
        let wrapper = block.firstChild;
        block.classList.toggle("is-scrollable", wrapper.offsetWidth < wrapper.scrollWidth);
    }

    const blocks = document.querySelectorAll(".js-table");
    blocks.forEach(fix);

    window.addEventListener("resize", debounce(() => {
        blocks.forEach(fix);
    }));
};
